module.exports = __webpack_public_path__ + "be-card-icon.png?fd71eaa8c76ad70f676ade825dd59614";